import { Mapper } from "../../../../base/utils/mapper";
import { CardiovascularScreeningResponseModel } from "../../../../domain/models/consult/cardiovascular-screening-response.model";
import { CardiovascularScreeningResponseEntity } from "../entities/cardiovascular-screening-response.entity";


export class CardiovascularScreeningImplementationRepositoryMapper extends Mapper<CardiovascularScreeningResponseEntity, CardiovascularScreeningResponseModel> {
    mapFrom(param: CardiovascularScreeningResponseEntity): CardiovascularScreeningResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CardiovascularScreeningResponseModel): CardiovascularScreeningResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}